<template>
    <svg :class="design" :width="width" :height="height" viewBox="0 0 11 10" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M6.49712 5L9.86848 1.6338C10.0635 1.43912 10.0635 1.12319 9.86848 0.928189L9.0851 0.146013C8.89012 -0.0486711 8.5737 -0.0486711 8.3784 0.146013L5.00736 3.51252L1.636 0.146326C1.44101 -0.0483586 1.1246 -0.0483586 0.929299 0.146326L0.146237 0.928189C-0.0487458 1.12287 -0.0487458 1.43881 0.146237 1.6338L3.5176 5L0.146237 8.3662C-0.0487458 8.56088 -0.0487458 8.87681 0.146237 9.07181L0.929612 9.85399C1.1246 10.0487 1.44101 10.0487 1.63631 9.85399L5.00736 6.48748L8.37872 9.85367C8.5737 10.0484 8.89012 10.0484 9.08541 9.85367L9.86879 9.0715C10.0638 8.87681 10.0638 8.56088 9.86879 8.36588L6.49712 5Z" :fill="fill"/>
    </svg>
</template>
<script>
    export default {
        name: 'ui-close-icon',
        props: {
            design: {
                type: String,
                default: ''
            },
            fill: {
                type: String,
                default: '#FFF'
            },
            width: {
                type: [String, Number],
                default: 16
            },
            height: {
                type: [String, Number],
                default: 18
            }
        }
    }
</script>